import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import React, { useEffect, useState, useRef } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import Popover from '@mui/material/Popover';
import dayjs from 'dayjs';
import debounce from 'lodash.debounce';
import DatePickerField from "../../common/DatePickerDashboard";
import { TableSortLabel } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import { formatDateWithFixedTimeNew } from "../../common/dateUtils";

import {
  Box,
  Button,
  Grid,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Stack,
  Pagination,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  TableContainer,
  Paper
} from "@mui/material";
import { useTheme, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import { exportTaskReportAction, getEmployeeSummaryAction } from "../../redux/actions/reportActions";
import { searchAgentAction } from "../../redux/actions/userActions";
import { getAllLocationsAction } from "../../redux/actions/agencyActions";
import NoDataFound from "../../common/NoDataFound";
import NoSearchResults from "../../common/helpers/NoSearchResults";

const TaskReport = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isFiltered, setIsFiltered] = useState(false);
  const [agentSearchTerm, setAgentSearchTerm] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
  const [showColumnToggle, setShowColumnToggle] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const handleDownloadClick = (event) => setDownloadAnchorEl(event.currentTarget);
  const handleDownloadClose = () => setDownloadAnchorEl(null);
  const [submittedFilters, setSubmittedFilters] = useState({});
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'lg'));

  const defaultColumns = {
    employeeName: true,
    openCount: true,
    closedCount: true,
    dueTodayCount: true,
    totalCount: true,
    location: true,
    agentName: true,
  };

  const [visibleColumns, setVisibleColumns] = useState(defaultColumns);

  const handleSort = (field) => {
    const isAsc = sortField === field && sortOrder === 'asc';
    setSortOrder(isAsc ? 'desc' : 'asc');
    setSortField(field);
  };

 const initialFormData = {
  taskType: '',
  priority: '',
  employeeId: '',
  locationId: '',
  createdBy: '',
  closedBy: '',
  fromDate: '',
  toDate: '',
  dueDate: '',
  customerNumber: '',
  policyNumber: '',
  agentName: '',
};

  const [filters, setFilters] = useState(initialFormData);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [hasSearched, setHasSearched] = useState(false);
  const [searchError, setSearchError] = useState('');
  const columnToggleRef = useRef(null);


  const production_report_data = useSelector(
    (state) => state.allReportReducer.get_task_status_report.content || []
  );

  const production_report_pagination = useSelector(
    (state) => state.allReportReducer.get_task_status_report || {}
  );
  const search_agent_list = useSelector(
    (state) => state.user.search_agent || {}
  );

  const get_all_location = useSelector(
    (state) => state?.agency?.get_all_locations_list || []
  );

  const agentOptions = search_agent_list.content || [];

  const handleAgentSearch = debounce((value) => {
    if (value?.length > 1) {
      dispatch(searchAgentAction(value));
    }
  }, 300);

  useEffect(() => {
  const handleClickOutside = (event) => {
    if (columnToggleRef.current && !columnToggleRef.current.contains(event.target)) {
      setShowColumnToggle(false);
    }
  };

  if (showColumnToggle) {
    document.addEventListener('mousedown', handleClickOutside);
  }

  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, [showColumnToggle]);

  useEffect(() => {
    if (get_all_location.length === 0) {
      dispatch(getAllLocationsAction());
    }
  }, [dispatch, get_all_location]);

useEffect(() => {
  if (isFiltered) {
    dispatch(getEmployeeSummaryAction(submittedFilters, page, rowsPerPage));
  }
}, [page, rowsPerPage, isFiltered, dispatch, submittedFilters]);

 const labelStyle = {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "500",
    lineHeight: "19.6px",
    textAlign: "left",
    marginBottom: "8px",
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? 'filter-popover' : undefined;

const handleDownloadCSV = async() => {
   await dispatch(exportTaskReportAction(submittedFilters, "csv"));
    };


const handleDownloadExcel = async() => {
   await dispatch(exportTaskReportAction(submittedFilters, "xlsx"));
};


const handleDownloadPDF = async() => {
   await dispatch(exportTaskReportAction(submittedFilters, "pdf"));
};


  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (page > 0 && production_report_pagination.totalPages > 0 && page >= production_report_pagination.totalPages) {
      setPage(0);
    }
  }, [production_report_pagination.totalPages]);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
  };

const handleSubmit = () => {
  const formattedFilters = {
    ...filters,
    fromDate: formatDateWithFixedTimeNew(filters.fromDate),
    toDate: formatDateWithFixedTimeNew(filters.toDate),
  };

  
  const cleanedFilters = Object.entries(formattedFilters).reduce(
    (acc, [key, value]) => {
      if (value !== '' && value !== null && value !== undefined && value !== 'All') {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );

  
  const allEmpty = Object.values(formattedFilters).every(
    (v) => v === '' || v === null || v === undefined
  );

  if (allEmpty) {
    
    setSearchError('Please fill at least one search field.');
    setHasSearched(false);
    return;
  }


  setSearchError('');

  setSubmittedFilters(cleanedFilters); 
  setIsFiltered(true);
  setPage(0);
  setHasSearched(true);
};



  const handleReset = () => {
    setFilters(initialFormData);
    setSubmittedFilters({});
    setIsFiltered(false);
    setPage(0);
    setAgentSearchTerm('');
    setHasSearched(false);
    setSearchError('');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const saved = localStorage.getItem('visible_columns');
    if (saved) {
      setVisibleColumns(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  return (
    <Box sx={{
      padding: isMobile ? '8px' : '24px',
      overflowX: 'auto',
      backgroundColor: '#ffffff',
      minHeight: '40vh',
	    marginBottom: '100px',
        '@media (min-width: 768px) and (max-width: 1024px)': {
          minHeight: '50vh',
          height: 'auto',
          overflowY: 'auto',
        },
        '@media (min-width: 1024px) and (min-height: 1366px)': {
          height: 'auto',
          minHeight: '70vh',
        },

    }}>
      {/* Header Section */}
      <Box sx={{
             display: "flex",
             flexDirection: isMobile ? "column" : "row",
             justifyContent: "space-between",
             alignItems: isMobile ? "flex-start" : "center",
             marginBottom: '16px',
             flexWrap: 'wrap',
             gap: 2
           }}>
            <Typography variant="h2">
                Report : Task Report {hasSearched && `(${production_report_pagination?.totalElements || 0})`}

            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: isMobile ? 'wrap' : 'nowrap' }}>
            <Button
              variant="outlined"
              onClick={handleDownloadClick}
              endIcon={<MoreVertIcon />}
              disabled={!hasSearched}
            >
              Download
            </Button>

            <Menu
              anchorEl={downloadAnchorEl}
              open={Boolean(downloadAnchorEl)}
              onClose={handleDownloadClose}
            >
              <MenuItem onClick={() => { handleDownloadExcel(); handleDownloadClose(); }}>Excel</MenuItem>
              <MenuItem onClick={() => { handleDownloadCSV(); handleDownloadClose(); }}>CSV</MenuItem>
              <MenuItem onClick={() => { handleDownloadPDF(); handleDownloadClose(); }}>PDF</MenuItem>
            </Menu>

           <Button
              variant="outlined"
              aria-describedby={popoverId}
              onClick={handleFilterClick}
            >
              Filter
            </Button>

            <Button
              variant="outlined"
              onClick={() => setShowColumnToggle((prev) => !prev)}
            >
              Select Columns
            </Button>
          </Box>

          {showColumnToggle && (
            <Box
             ref={columnToggleRef}
              sx={{
                position: 'absolute',
                top: isMobile ? '180px' : '200px',
                right: isMobile ? '10px' : '30px',
                zIndex: 10,
                backgroundColor: 'white',
                border: '1px solid #ccc',
                borderRadius: 2,
                padding: 2,
                boxShadow: 3,
                maxHeight: 400,
                overflowY: 'auto',
                maxWidth: isMobile ? '180px' : '200px'
              }}
            >
              <Typography fontWeight={600} mb={1}>Select Columns</Typography>
              {Object.keys(defaultColumns).map((column) => (
                <FormControlLabel
                  key={column}
                  control={
                    <Checkbox
                      checked={visibleColumns[column]}
                      onChange={() =>
                        setVisibleColumns((prev) => ({
                          ...prev,
                          [column]: !prev[column],
                        }))
                      }
                       size={isMobile ? "small" : "medium"}
                    />
                  }
                label={
                  <Typography fontSize={isMobile ? "12px" : "14px"}>
                    {column.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())}
                  </Typography>
                }
                />
              ))}
            </Box>
          )}

            <Popover
            id={popoverId}
            open={open}
            anchorEl={anchorEl}
            onClose={handleFilterClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '& .MuiPaper-root': {
                width: isMobile ? '100%' : 'auto',
                maxWidth: isMobile ? 'calc(100% - 32px)' : '1000px',
                minWidth: isMobile ? 'unset' : '500px',
                margin: isMobile ? '0 16px' : 0,
                maxHeight: '80vh',
                overflow: 'auto',
                position: isMobile ? 'fixed' : undefined,
                left: isMobile ? '0' : undefined,
                right: isMobile ? '0' : undefined,
                borderRadius: isMobile ? '8px 8px 0 0' : undefined,
              }
            }}
            disableScrollLock={true}
            anchorReference={isMobile ? 'none' : 'anchorEl'}
            marginThreshold={0}
            PaperProps={{
              style: {
                transform: isMobile ? 'none' : 'translateY(8px)',
              },
            }}
            ModalProps={{
              style: {
                alignItems: isMobile ? 'flex-end' : undefined,
              }
            }}
          >
  <Box sx={{ p: { xs: 1, sm: 2 } }}>
    <Grid container spacing={{ xs: 1, sm: 2 }}>
      <Grid item xs={12} sm={6} md={3}>
        <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>From Date</label>
        <DatePickerField
          fieldName="fromDate"
          formData={filters}
          handleDateChange={(name, value) => handleFilterChange({ target: { name, value } })}
          handleBlur={(fieldName, error) => {
            setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
            setFieldErrors((prev) => ({ ...prev, [fieldName]: error }));
          }}
          touchedFields={touchedFields}
          fieldErrors={fieldErrors}
          size={isMobile ? "small" : "medium"}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              height: { xs: '40px', sm: '55px' }
            }
          }}
        />
      </Grid>

      {/* Closed Date */}
      <Grid item xs={12} sm={6} md={3}>
        <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>To Date</label>
        <DatePickerField
          fieldName="toDate"
          formData={filters}
          handleDateChange={(name, value) => handleFilterChange({ target: { name, value } })}
          handleBlur={(fieldName, error) => {
            setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
            setFieldErrors((prev) => ({ ...prev, [fieldName]: error }));
          }}
          touchedFields={touchedFields}
          fieldErrors={fieldErrors}
          size={isMobile ? "small" : "medium"}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              height: { xs: '40px', sm: '55px' }
            }
          }}
        />
      </Grid>

      {/* Due Date */}
      <Grid item xs={12} sm={6} md={3}>
        <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>Due Date</label>
        <DatePickerField
          fieldName="dueDate"
          formData={filters}
          handleDateChange={(name, value) => handleFilterChange({ target: { name, value } })}
          handleBlur={(fieldName, error) => {
            setTouchedFields((prev) => ({ ...prev, [fieldName]: true }));
            setFieldErrors((prev) => ({ ...prev, [fieldName]: error }));
          }}
          touchedFields={touchedFields}
          fieldErrors={fieldErrors}
          size={isMobile ? "small" : "medium"}
          sx={{
            width: '100%',
            '& .MuiInputBase-root': {
              height: { xs: '40px', sm: '55px' }
            }
          }}
        />
      </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
        Location
      </label>
      <Autocomplete
        freeSolo
        options={get_all_location}
        getOptionLabel={(option) =>
          typeof option === 'string'
            ? option
            : option.locationDescription || ''
        }
        renderOption={(props, option) => (
          <li {...props}>
            {option.locationDescription}
          </li>
        )}
        onInputChange={(e, newInputValue) => {
          setFilters((prev) => ({
            ...prev,
            location: newInputValue
          }));
        }}
        onChange={(e, newValue) => {
          setFilters((prev) => ({
            ...prev,
            location: newValue?.locationDescription || newValue || ''
          }));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size={isMobile ? "small" : "medium"}
            placeholder="Select Location"
            value={filters.location}
            onChange={(e) => {
              setFilters((prev) => ({
                ...prev,
                location: e.target.value
              }));
            }}
            sx={{
              width: '100%',
              '& .MuiInputBase-root': {
                height: isMobile ? '40px' : '55px'
              }
            }}
          />
        )}
      />
    </Grid>

    <Grid item xs={12} sm={6} md={3}>
      <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
        Task Type
      </label>
      <Autocomplete
        fullWidth
        size={isMobile ? "small" : "medium"}
          options={[
            "All",
            "Cancelled policy",
            "Renewal",
            "New Business"
          ]}
          value={filters.taskType }
          onChange={(event, newValue) => {
            setFilters({ ...filters, taskType: newValue || '' });
          }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Task Type"
            sx={{
              "& .MuiInputBase-root": {
                height: { xs: "40px", sm: "55px" },
              },
            }}
          />
        )}
      />
    </Grid>

    {/* Priority */}
    <Grid item xs={12} sm={6} md={3}>
      <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
        Priority
      </label>
      <Autocomplete
        fullWidth
        size={isMobile ? "small" : "medium"}
        options={["All", "HIGH", "MEDIUM", "LOW"]}
        value={filters.priority}
        onChange={(event, newValue) => {
          setFilters({ ...filters, priority: newValue || '' });
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Priority"
            sx={{
              "& .MuiInputBase-root": {
                height: { xs: "40px", sm: "55px" },
              },
            }}
          />
        )}
      />
    </Grid>

      {/* Agent Name */}
    <Grid item xs={12} sm={6} md={3}>
      <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
        Agent Name
      </label>
      <Autocomplete
        options={agentOptions}
        getOptionLabel={(option) =>
          typeof option === 'string'
            ? option
            : `${option.firstName || ''} ${option.lastName || ''}`
        }
        renderOption={(props, option) => (
          <li {...props}>
            {option.firstName} {option.lastName}
          </li>
        )}
        onInputChange={(e, newInputValue) => {
          setAgentSearchTerm(newInputValue);
          handleAgentSearch(newInputValue);
        }}
        onChange={(e, newValue) => {
          setFilters((prev) => ({
            ...prev,
            agentName: newValue?.firstName
              ? `${newValue.firstName} ${newValue.lastName}`
              : newValue || ''
          }));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            size={isMobile ? "small" : "medium"}
            placeholder="Search Agent"
            value={agentSearchTerm}
            onChange={(e) => {
              setAgentSearchTerm(e.target.value);
            }}
            sx={{
              width: '100%',
              '& .MuiInputBase-root': {
                height: isMobile ? '40px' : '55px'
              }
            }}
          />
        )}
      />
    </Grid>


      <Grid item xs={12} display="flex" justifyContent="flex-end" gap={1}>
        <Button
          onClick={handleReset}
          variant="outlined"
        >
          Reset
        </Button>
        <Button
          onClick={() => {
            handleSubmit();
            handleFilterClose();
          }}
          variant="outlined"
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  </Box>
</Popover>
        </Box>
 <Box mb={3} p={2} sx={{ border: '1px solid #e0e0e0', borderRadius: '8px' }}>
     <Box sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 2,
        flexWrap: isMobile ? 'wrap' : 'nowrap',
        overflowX: 'auto',
        marginBottom: "10px",
        '& > *': {
          minWidth: isMobile ? '120px' : '180px'
        }
      }}>
        {[
          { name: 'policyNumber', label: 'Policy Number' },
          { name: 'customerNumber', label: 'Customer Name' }
        ].map(field => (
    <Box key={field.name}>
      <label style={{ fontSize: 14, fontWeight: 500, display: 'block', marginBottom: 4 }}>
        {field.label}
      </label>
      <TextField
        name={field.name}
        size="small"
        value={filters[field.name]}
        onChange={handleFilterChange}
        fullWidth
        sx={{
          '& .MuiInputBase-root': {
            height: 55
          }
        }}
        inputProps={{
          
          pattern: undefined,
          maxLength: undefined
        }}
      />
    </Box>
      ))}
      <Grid item xs={12} sm={6} md={3}>
  <label
    style={{
      fontSize: isMobile ? "12px" : isTablet ? "13px" : "14px",
      fontWeight: 500,
      display: "block",
      marginBottom: 4,
      width:'220px'
    }}
  >
    Created By
  </label>
  <Autocomplete
  value={
    agentOptions.find((opt) => opt.id === filters.createdBy) || null
  }
    options={agentOptions}
    getOptionLabel={(option) =>
      typeof option === "string"
        ? option
        : `${option.firstName || ""} ${option.lastName || ""}`
    }
    renderOption={(props, option) => (
      <li {...props}>
        {option.firstName} {option.lastName}
      </li>
    )}
    onInputChange={(e, newInputValue) => {
      setAgentSearchTerm(newInputValue);
      handleAgentSearch(newInputValue);
    }}
    onChange={(e, newValue) => {
      setFilters((prev) => ({
        ...prev,
        createdBy: newValue?.id || ""
      }));
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder="Search Created By"
        value={agentSearchTerm}
        onChange={(e) => {
          setAgentSearchTerm(e.target.value);
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: {
              xs: "36px",
              sm: "38px",
              md: "55px",
              lg: "55px",
            },
          },
        }}
      />
    )}
  />
</Grid>


        <Grid item xs={12} sm={6} md={3}>
  <label
    style={{
      fontSize: isMobile ? "12px" : isTablet ? "13px" : "14px",
      fontWeight: 500,
      display: "block",
      marginBottom: 4,
      width:'220px'
    }}
  >
    Closed By
  </label>
  <Autocomplete
  value={
    agentOptions.find((opt) => opt.id === filters.closedBy) || null
  }
    options={agentOptions}
    getOptionLabel={(option) =>
      typeof option === "string"
        ? option
        : `${option.firstName || ""} ${option.lastName || ""}`
    }
    renderOption={(props, option) => (
      <li {...props}>
        {option.firstName} {option.lastName}
      </li>
    )}
    onInputChange={(e, newInputValue) => {
      setAgentSearchTerm(newInputValue);
      handleAgentSearch(newInputValue);
    }}
    onChange={(e, newValue) => {
      setFilters((prev) => ({
        ...prev,
        closedBy: newValue?.id || ""
      }));
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        size="small"
        placeholder="Search Closed By"
        value={agentSearchTerm}
        onChange={(e) => {
          setAgentSearchTerm(e.target.value);
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: {
              xs: "36px",
              sm: "38px",
              md: "55px",
              lg: "55px",
            },
          },
        }}
      />
    )}
  />
</Grid>

     <Box sx={{ display: 'flex', gap: 2 }}>
  <Box>
    <label style={{ display: 'block' }}>&nbsp;</label>
    <Button
      onClick={handleSubmit}
      variant="outlined"
    >
      Search
    </Button>
  </Box>

  <Box>
    <label style={{ display: 'block' }}>&nbsp;</label>
    <Button
      onClick={handleReset}
      variant="outlined"
    >
      Reset
    </Button>
  </Box>
</Box>

</Box>
{searchError && (
  <Typography
    sx={{ color: "#D32F2F", fontSize: "12px",
          mt: 1, mb: 2, textAlign: "left",
        }}
  >
    {searchError}
  </Typography>
)}

</Box>
{!hasSearched ? (
  <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '200px',
                  backgroundColor: '#f9f9f9',
                  borderRadius: 2,
                  border: '1px solid #e0e0e0'
                }}>
   <NoDataFound discription={"Please use the search filters above to fetch and display updated Task Report data."} />
    </Box>
) : production_report_data.length === 0 ? (
  <TableRow>
      <TableCell colSpan={Object.keys(visibleColumns).filter(key => visibleColumns[key]).length} align="center" sx={{pl:70}}>
        <NoSearchResults />
      </TableCell>
    </TableRow>
) : (
  <TableContainer
    component={Paper}
    sx={{
      maxHeight: isMobile ? "60vh" : "none",
      overflow: "auto",
      width: "100%",
      marginBottom: "16px",
    }}
  >
        <Table
          stickyHeader
          sx={{
            minWidth: isMobile ? '100%' : '650px',
            '& .MuiTableCell-root': {
              fontSize: isMobile ? '12px' : '14px',
              padding: isMobile ? '8px' : '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: isMobile ? '100px' : '200px'
            }
          }}
          aria-label="policy table"
          size={isMobile ? "small" : "medium"}
        >
        <TableHead sx={{ backgroundColor: '#F6C21E' }}>
            <TableRow sx={{ backgroundColor: '#F6C21E' }}>
              {visibleColumns.employeeName && (
                <TableCell  className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }}
                sortDirection={sortField === 'employeeName' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'employeeName'}
                    direction={sortField === 'employeeName' ? sortOrder : 'asc'}
                    onClick={() => handleSort('employeeName')}
                  >
                    Employee Name
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.openCount && (
                <TableCell  className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'openCount' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'openCount'}
                    direction={sortField === 'openCount' ? sortOrder : 'asc'}
                    onClick={() => handleSort('openCount')}
                  >
                    Open Count
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.closedCount && (
                <TableCell  className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'closedCount' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'closedCount'}
                    direction={sortField === 'closedCount' ? sortOrder : 'asc'}
                    onClick={() => handleSort('closedCount')}
                  >
                    Closed Count
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.dueTodayCount && (
                <TableCell className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'dueTodayCount' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'dueTodayCount'}
                    direction={sortField === 'dueTodayCount' ? sortOrder : 'asc'}
                    onClick={() => handleSort('dueTodayCount')}
                  >
                    Due Today Count
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.totalCount && (
                <TableCell  className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'totalCount' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'totalCount'}
                    direction={sortField === 'totalCount' ? sortOrder : 'asc'}
                    onClick={() => handleSort('totalCount')}
                  >
                    Total Count
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.location && (
                <TableCell  className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'location' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'location'}
                    direction={sortField === 'location' ? sortOrder : 'asc'}
                    onClick={() => handleSort('location')}
                  >
                    Location
                  </TableSortLabel>
                </TableCell>
              )}
              {visibleColumns.agentName && (
                <TableCell className="styled-table-heading" sx={{
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  top: 0,
                  fontSize: isMobile ? '12px' : '14px',
                  padding: isMobile ? '8px' : '12px'
                }} sortDirection={sortField === 'agentName' ? sortOrder : false}>
                  <TableSortLabel
                    active={sortField === 'agentName'}
                    direction={sortField === 'agentName' ? sortOrder : 'asc'}
                    onClick={() => handleSort('agentName')}
                  >
                    Agent
                  </TableSortLabel>
                </TableCell>
              )}
            </TableRow>
          </TableHead>

         <TableBody>
            {!isFiltered ? (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length} align="center">
                  Please use filters above and click Search to view results.
                </TableCell>
              </TableRow>
            ) : production_report_data.length > 0 ? (
              production_report_data.map((row, index) => (
                <TableRow className="styled-table-row" key={index}>
                  {visibleColumns.employeeName && <TableCell>{row.employeeName}</TableCell>}
                  {visibleColumns.openCount && <TableCell>{row.openCount}</TableCell>}
                  {visibleColumns.closedCount && <TableCell>{row.closedCount}</TableCell>}
                  {visibleColumns.dueTodayCount && <TableCell>{row.dueTodayCount}</TableCell>}
                  {visibleColumns.totalCount && <TableCell>{row.totalCount}</TableCell>}
                  {visibleColumns.location && <TableCell>{row.location}</TableCell>}
                  {visibleColumns.agentName && (<TableCell>
                  {row.agentName || `${row.agentFirstName || ''} ${row.agentLastName || ''}`.trim() || '-'}
                      </TableCell>
                    )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={Object.values(visibleColumns).filter(Boolean).length} align="center">
                  Searching ...
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    )}

     {hasSearched && production_report_pagination?.totalElements > 0 && (
        <Box sx={{
          width: '100%',
          overflow: 'hidden',
          padding: '0px 0'
        }}>
          <Stack
           direction={isMobile ? 'column' : 'row'}
            justifyContent="flex-end"
            alignItems="center"
            flexWrap="wrap"
            spacing={2}
          >
            {/* Rows per page dropdown */}
            <Box display="flex" alignItems="center">
              <Typography variant="body2" sx={{ fontSize: '12px', marginRight: '8px' }}>
                Rows per page:
              </Typography>
              <Select
                value={rowsPerPage}
                onChange={handleChangeRowsPerPage}
                size="small"
                sx={{ fontSize: '12px', minWidth: '80px' }}
              >
                {[5, 10, 15, 25, 50, 100].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </Box>

            {/* Pagination controls */}
            <Pagination
              count={production_report_pagination.totalPages}
              page={page + 1}
              onChange={(e, value) => handleChangePage(e, value - 1)}
              showFirstButton
              showLastButton
              siblingCount={isMobile ? 0 : 1}
              boundaryCount={isMobile ? 0 : 1}
              size={isMobile ? "small" : "medium"}
            />
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default TaskReport;